
import Vue from 'vue'
import ConfirmComponent from './tpl'
// import mergin from ''



let instance;

let config = {};

let ConfirmConstructor = Vue.extend(ConfirmComponent);

let initInstance = ()=> {
    instance = new ConfirmConstructor ({
        el:document.createElement('div')
    });
    document.body.appendChild(instance.$el);
};
let Confirm = (content,title = '',options={}) => {
    initInstance();
    instance.content = content;
    instance.title = title || '提示';
    instance.isredbtn = options.isredbtn || false;
    instance.canceltxt = options.canceltxt || '取消';
    instance.confirmtxt = options.confirmtxt || '确认';

    return new Promise((resolve,reject) => {
        instance.show = true;
        let success = instance.success;
        let cancel = instance.cancel;
        instance.success =()=> {
            // success();
            resolve(true);
            instance.show = false;
        };
        instance.cancel = ()=>{
            // cancel();
            reject(false);
            instance.show = false;
            // setTimeout(()=>{
            //
            //     // document.body.removeChild(instance.$el);
            // },2000)

        }
    })
};


// export default {
//     install:function (Vue,options = {}) {
//         // config = options;
//         Vue.prototype.$confirm = Confirm;
//         // Vue.component('confirm',ConfirmComponent)
//     }
// }
export default {
    install:function (Vue,options = {}) {
        // config = options;
        Vue.prototype.$ztxConfirm = Confirm;
        // Vue.component('confirm',ConfirmComponent)
    }
}


// WEBPACK FOOTER //
// ./src/components/Confirm/index.js